import { AddCircle, Edit } from "@mui/icons-material";
import { Button, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { StyledFecadeAccidentCard } from "../../../../styled/accident";

// Styled components

const FacadeAccidentCards = ({ accidents, handleAdd, handleEdit }) => {
  return accidents.map((accident) => (
    <StyledFecadeAccidentCard.Card elevation={2} key={accident.nroSiniestroArt}>
      <StyledFecadeAccidentCard.CardLeftContainer>
        <Typography>
          <b>Nº Siniestro:</b> {accident.nroSiniestroArt}
        </Typography>
        <Typography>
          <b>Fecha hora accidente:</b>{" "}
          {accident.fechaHoraAccidente ? moment(accident.fechaHoraAccidente).format("DD/MM/YYYY HH:mm") : ""}
        </Typography>
        <Typography>
          <b>Diagnóstico:</b> {accident.diagnostico}
        </Typography>
        <Typography>
          <b>Empleador:</b> {accident.razonSocialEmpleador} (
          {accident.cuitEmpleador})
        </Typography>
        <Typography>
          <b>Referente:</b> {accident.referenteApellidoyNombre}
        </Typography>
        <Typography>
          <b>Referente Email:</b> {accident.referenteEmail}
        </Typography>
      </StyledFecadeAccidentCard.CardLeftContainer>
      <StyledFecadeAccidentCard.CardRightContainer>
        {handleAdd ? (
          <Tooltip title="Ingresar Siniestro">
            <Button
              variant="contained"
              type="submit"
              color="primary"
              onClick={() => handleAdd(accident, null)}>
              <AddCircle />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title="Actualizar Siniestro">
            <Edit onClick={() => handleEdit(accident, null)} />
          </Tooltip>
        )}
      </StyledFecadeAccidentCard.CardRightContainer>
    </StyledFecadeAccidentCard.Card>
  ));
};

export default FacadeAccidentCards;
